module.exports = __webpack_public_path__ + "static/media/ciara.f69daac6.jpg";